import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })

export class LoadingService {
  private _loading = new BehaviorSubject<boolean>(false);
  isLoading = this._loading?.asObservable();

  show() { 
    setTimeout(()=>{
      this._loading?.next(true); 
    },0);
  }
  hide() { 
    setTimeout(()=>{
      this._loading?.next(false); 
    },0);
  }
}
